<template>
<v-card>
  <v-list three-line class="py-0">
    <v-list-tile avatar @click="$emit('click',contact)">
      <v-list-tile-avatar>
        <v-icon size="32" color="primary">person</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title class="brown--text">{{ contact.name }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ contact.email }}</v-list-tile-sub-title>
        <v-list-tile-sub-title>{{ contact.sms }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'ContactItem',
  mixins: [UserAuth],
  props: {
    contact: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactItem.vue